import React, { useState } from 'react';
import * as Styles from './FAQ.styles';

const FAQ = ({ locale }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Styles.Wrapper>
      <Styles.Title>{locale.title}</Styles.Title>
      <Styles.ItemList>
        {locale.items.map((item, index) => (
          <Styles.Item key={item.question} onClick={() => handleToggle(index)}>
            <Styles.QuestionRow>
              <Styles.Question>{item.question}</Styles.Question>
              <Styles.ToggleIcon>
                {openIndex === index ? '\u2212' : '+'}
              </Styles.ToggleIcon>
            </Styles.QuestionRow>
            {openIndex === index && (
              <Styles.Answer>{item.answer}</Styles.Answer>
            )}
          </Styles.Item>
        ))}
      </Styles.ItemList>
    </Styles.Wrapper>
  );
};

export default FAQ;
